

















































































































































































































































































































































































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ITask, ReorderTasksDto, TaskStatus } from 'admiral-core';
import {
  ArrowDownIcon,
  ArrowUpIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  PlusIcon,
} from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import draggable from 'vuedraggable';
import { TaskApi } from '@/services/TaskApi';
import {
  buildFullOrderedIdsForStatus,
  compareTasksByStatusOrder,
  getDraggedTaskIdFromSortableItem,
  resolveListStatus,
} from '@/utils/taskListOrder';
import { PolicyApi } from '@/services/PolicyApi';
import { DamageApi } from '@/services/DamageApi';
import TaskListViewItem from './TaskListViewItem.vue';
import TaskListSingletonMenus from '@/components/tasks/TaskListSingletonMenus.vue';
import type { TaskListSingletonMenuState } from '@/components/tasks/TaskListSingletonMenuState';
import TaskStatusIcon from '@/components/tasks/TaskStatusIcon.vue';
import TaskSectionSortMenu from '@/components/tasks/TaskSectionSortMenu.vue';
import type { SectionSortField } from '@/components/tasks/SectionSortField';
import EditPolicyModal from '@/views/pages/policies/EditPolicyModal.vue';
import EditDamageModal from '@/views/pages/damages/EditDamageModal.vue';
import { BModal } from 'bootstrap-vue';

@Component({
  name: 'Tasks2TaskOverview',
  components: {
    TaskListViewItem,
    TaskListSingletonMenus,
    TaskSectionSortMenu,
    ArrowDownIcon,
    ArrowUpIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    PlusIcon,
    draggable,
    TaskStatusIcon,
    EditPolicyModal,
    EditDamageModal,
  },
})
export default class TaskOverview extends mixins(BaseMixin) {
  @Prop({ required: true, type: Array })
  tasks!: ITask[];

  /** Full task list (unfiltered) for persisting order when filters hide some tasks. */
  @Prop({ type: Array, required: false })
  tasksForReorder?: ITask[];

  @Prop({
    type: Object,
    required: false,
    default: () => ({ showDemo: false }),
  })
  taskReorderContext?: Pick<
    ReorderTasksDto,
    | 'showDemo'
    | 'tags'
    | 'users'
    | 'priority'
    | 'backoffice'
    | 'important'
    | 'completedListLimit'
    | 'archivedListLimit'
  >;

  @Prop({ type: Boolean, default: false })
  showLoadMoreCompleted!: boolean;

  @Prop({ type: Boolean, default: false })
  loadingMoreCompleted!: boolean;

  @Prop({ type: Boolean, default: false })
  showLoadMoreArchived!: boolean;

  @Prop({ type: Boolean, default: false })
  loadingMoreArchived!: boolean;

  /**
   * While tasks2 search is active, expand collapsed „Erledigt“ / „Archiviert“ when the filtered
   * list has rows there so matches are not hidden behind section headers.
   */
  @Prop({ type: Boolean, default: false })
  expandTerminalForActiveSearch!: boolean;

  TaskStatus = TaskStatus;
  selectedPolicy: any = null;
  selectedDamage: any = null;

  listSingletonMenu: TaskListSingletonMenuState | null = null;

  expandedSections: Record<TaskStatus, boolean> = {
    [TaskStatus.TODO]: true,
    [TaskStatus.IN_PROGRESS]: true,
    [TaskStatus.IN_WAITING]: true,
    [TaskStatus.COMPLETED]: false,
    [TaskStatus.ARCHIVED]: false,
  };

  /** Which column to sort by for this section (`manual` = server / drag order). */
  sectionSortField: Record<TaskStatus, SectionSortField> = {
    [TaskStatus.TODO]: 'manual',
    [TaskStatus.IN_PROGRESS]: 'manual',
    [TaskStatus.IN_WAITING]: 'manual',
    [TaskStatus.COMPLETED]: 'manual',
    [TaskStatus.ARCHIVED]: 'manual',
  };

  /**
   * When sorting by a date: `true` = absteigend (neueste/späteste zuerst je nach Feld),
   * `false` = aufsteigend. Ignored when `manual`.
   */
  sectionSortDesc: Record<TaskStatus, boolean> = {
    [TaskStatus.TODO]: true,
    [TaskStatus.IN_PROGRESS]: true,
    [TaskStatus.IN_WAITING]: true,
    [TaskStatus.COMPLETED]: true,
    [TaskStatus.ARCHIVED]: true,
  };

  toggleExpanded(section: TaskStatus) {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  onOpenListSingletonMenu(payload: TaskListSingletonMenuState) {
    if (
      this.listSingletonMenu &&
      this.listSingletonMenu.task.id === payload.task.id &&
      this.listSingletonMenu.kind === payload.kind
    ) {
      this.listSingletonMenu = null;
      return;
    }
    this.listSingletonMenu = payload;
  }

  /**
   * Mutable per-status lists — vuedraggable must mutate stable arrays, not computed getters.
   * Rebuilt only when the `tasks` prop reference changes (e.g. API reload).
   */
  listByStatus: Record<TaskStatus, ITask[]> = {
    [TaskStatus.TODO]: [],
    [TaskStatus.IN_PROGRESS]: [],
    [TaskStatus.IN_WAITING]: [],
    [TaskStatus.COMPLETED]: [],
    [TaskStatus.ARCHIVED]: [],
  };

  @Watch('tasks', { immediate: true })
  onTasksPropUpdated(tasks: ITask[]) {
    const source = Array.isArray(tasks) ? tasks : [];
    this.listByStatus = this.buildGroupedTasksFromTasks(source);
    this.applySectionSorts();
    this.expandCollapsedTerminalSectionsForActiveSearch();
  }

  @Watch('expandTerminalForActiveSearch')
  onExpandTerminalForActiveSearchChanged(active: boolean) {
    if (active) {
      this.expandCollapsedTerminalSectionsForActiveSearch();
    }
  }

  /**
   * When toolbar search is on and COMPLETED/ARCHIVED contain filtered tasks, ensure those sections are expanded.
   */
  expandCollapsedTerminalSectionsForActiveSearch() {
    if (!this.expandTerminalForActiveSearch) return;
    if (this.listByStatus[TaskStatus.COMPLETED].length > 0) {
      this.$set(this.expandedSections, TaskStatus.COMPLETED, true);
    }
    if (this.listByStatus[TaskStatus.ARCHIVED].length > 0) {
      this.$set(this.expandedSections, TaskStatus.ARCHIVED, true);
    }
  }

  isManualSort(section: TaskStatus): boolean {
    return this.sectionSortField[section] === 'manual';
  }

  setSectionSortField(section: TaskStatus, field: SectionSortField) {
    const previous = this.sectionSortField[section];
    if (field !== 'manual' && previous !== field) {
      // Sinnvolle Defaults beim Wechsel des Datumsfelds (wie Filter-Property)
      if (field === 'dueAt') this.sectionSortDesc[section] = false;
      else this.sectionSortDesc[section] = true;
    }
    this.sectionSortField[section] = field;
    this.applySort(section);
  }

  toggleSortDirection(section: TaskStatus) {
    this.sectionSortDesc[section] = !this.sectionSortDesc[section];
    this.applySort(section);
  }

  sortDirectionTooltip(section: TaskStatus): string {
    const field = this.sectionSortField[section];
    const desc = this.sectionSortDesc[section];
    if (field === 'createdAt') {
      return desc ? 'Neueste zuerst' : 'Älteste zuerst';
    }
    if (field === 'updatedAt') {
      return desc ? 'Zuletzt bearbeitet zuerst' : 'Am längsten unverändert zuerst';
    }
    if (field === 'dueAt') {
      return desc ? 'Späteste Fälligkeit zuerst' : 'Früheste Fälligkeit zuerst';
    }
    return '';
  }

  private applySectionSorts() {
    this.applySort(TaskStatus.TODO);
    this.applySort(TaskStatus.IN_PROGRESS);
    this.applySort(TaskStatus.IN_WAITING);
    this.applySort(TaskStatus.COMPLETED);
    this.applySort(TaskStatus.ARCHIVED);
  }

  private applySort(section: TaskStatus) {
    const sectionList = this.listByStatus[section];
    if (!sectionList) return;

    const field = this.sectionSortField[section];
    const desc = this.sectionSortDesc[section];

    if (field === 'manual') {
      sectionList.sort(compareTasksByStatusOrder);
      return;
    }

    if (field === 'createdAt') {
      sectionList.sort((a, b) => {
        const cmp = this.taskTs(a.createdAt) - this.taskTs(b.createdAt);
        return desc ? -cmp : cmp;
      });
      return;
    }

    if (field === 'updatedAt') {
      sectionList.sort((a, b) => {
        const cmp = this.taskTs(a.updatedAt) - this.taskTs(b.updatedAt);
        return desc ? -cmp : cmp;
      });
      return;
    }

    if (field === 'dueAt') {
      sectionList.sort((a, b) => {
        const aTs = a.dueAt
          ? this.taskTs(a.dueAt)
          : desc
          ? Number.NEGATIVE_INFINITY
          : Number.POSITIVE_INFINITY;
        const bTs = b.dueAt
          ? this.taskTs(b.dueAt)
          : desc
          ? Number.NEGATIVE_INFINITY
          : Number.POSITIVE_INFINITY;
        if (aTs !== bTs) return desc ? bTs - aTs : aTs - bTs;
        return this.taskTs(b.updatedAt) - this.taskTs(a.updatedAt);
      });
      return;
    }

    sectionList.sort(compareTasksByStatusOrder);
  }

  private taskTs(value: string | Date | undefined | null): number {
    if (value == null || value === '') return 0;
    const t = new Date(value as string).getTime();
    return Number.isNaN(t) ? 0 : t;
  }

  buildGroupedTasksFromTasks(tasks: ITask[]): Record<TaskStatus, ITask[]> {
    const groups: Record<TaskStatus, ITask[]> = {
      [TaskStatus.TODO]: [],
      [TaskStatus.IN_PROGRESS]: [],
      [TaskStatus.IN_WAITING]: [],
      [TaskStatus.COMPLETED]: [],
      [TaskStatus.ARCHIVED]: [],
    };
    const validStatuses = new Set(Object.values(TaskStatus));
    for (const t of tasks) {
      const status = t.status && validStatuses.has(t.status) ? t.status : TaskStatus.TODO;
      groups[status].push(t);
    }
    for (const arr of Object.values(groups)) {
      if (arr) arr.sort(compareTasksByStatusOrder);
    }
    return groups;
  }

  get reorderBasis(): ITask[] {
    return this.tasksForReorder != null ? this.tasksForReorder : this.tasks;
  }

  patchSortOrders(status: TaskStatus, orderedIds: string[]) {
    orderedIds.forEach((id, idx) => {
      const t = this.reorderBasis.find((x) => x.id === id);
      if (t && t.status === status) {
        this.$set(t, 'statusSortOrder', idx);
      }
    });
  }

  async onDragEnd(evt: any) {
    if (evt.oldDraggableIndex === evt.newDraggableIndex && evt.from === evt.to) return;

    const movedId = getDraggedTaskIdFromSortableItem(evt.item as HTMLElement);
    if (!movedId) return;

    const moved = this.reorderBasis.find((t) => t.id === movedId);
    if (!moved) return;

    const fromEl = evt.from as HTMLElement;
    const toEl = evt.to as HTMLElement;
    const newStatus = resolveListStatus(toEl);
    if (!newStatus) return;

    const previousStatus = moved.status;
    this.$set(moved, 'status', newStatus);
    await this.$nextTick();

    try {
      if (previousStatus !== newStatus) {
        await TaskApi.updateStatus(moved.id, moved, newStatus);
      }

      const agency = this.user.agency;
      const toOrder = buildFullOrderedIdsForStatus(newStatus, toEl, this.reorderBasis);
      await TaskApi.reorder({
        agency,
        status: newStatus,
        orderedTaskIds: toOrder,
        ...(this.taskReorderContext || {}),
      });
      this.patchSortOrders(newStatus, toOrder);

      if (previousStatus !== newStatus) {
        const fromOrder = buildFullOrderedIdsForStatus(previousStatus, fromEl, this.reorderBasis);
        await TaskApi.reorder({
          agency,
          status: previousStatus,
          orderedTaskIds: fromOrder,
          ...(this.taskReorderContext || {}),
        });
        this.patchSortOrders(previousStatus, fromOrder);
      }

      this.$emit('reload');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Task drag/reorder failed', e);
      this.$toastr.e('Verschieben fehlgeschlagen');
      this.$emit('reload');
    }
  }

  async openEditPolicyModal(policy: any) {
    try {
      const response = await PolicyApi.getPolicy(policy.id);
      this.selectedPolicy = response.data;
      ((this.$refs['edit-policy-modal'] as EditPolicyModal).$refs['edit-policy'] as BModal).show();
    } catch (e) {
      this.$toastr.e('Anbahnung konnte nicht geladen werden.');
    }
  }

  async openEditDamageModal(damage: any) {
    try {
      const response = await DamageApi.getDamage(damage.id);
      this.selectedDamage = response.data;
      ((this.$refs['edit-damage-modal'] as EditDamageModal).$refs['edit-damage'] as BModal).show();
    } catch (e) {
      this.$toastr.e('Schaden konnte nicht geladen werden.');
    }
  }
}
